var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLocation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.17,
    height: 14.528,
    viewBox: "0 0 10.17 14.528",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_place_24px",
    d: "M10.085,2A5.081,5.081,0,0,0,5,7.085c0,3.814,5.085,9.443,5.085,9.443S15.17,10.9,15.17,7.085A5.081,5.081,0,0,0,10.085,2Zm0,6.9A1.816,1.816,0,1,1,11.9,7.085,1.817,1.817,0,0,1,10.085,8.9Z",
    transform: "translate(-5 -2)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-location.05317b45db63decb5387365b86aa69f5.svg";